/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_No_Upcoming_EventsInputs */

const en_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No upcoming events`)
};

const de_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine kommenden Events.`)
};

const es_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay eventos próximos.`)
};

const fr_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun évènement prévu.`)
};

const nl_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen aankomende Events`)
};

const it_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento in programma.`)
};

const pt_br2_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento próximo.`)
};

const pl_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak nadchodzących wydarzeń.`)
};

const hu_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincsenek közelgő események.`)
};

const ro_admin_dashboard_no_upcoming_events = /** @type {(inputs: Admin_Dashboard_No_Upcoming_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niciun eveniment viitor`)
};

/**
* | output |
* | --- |
* | "No upcoming events" |
*
* @param {Admin_Dashboard_No_Upcoming_EventsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_no_upcoming_events = /** @type {((inputs?: Admin_Dashboard_No_Upcoming_EventsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_No_Upcoming_EventsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_no_upcoming_events(inputs)
	if (locale === "de") return de_admin_dashboard_no_upcoming_events(inputs)
	if (locale === "es") return es_admin_dashboard_no_upcoming_events(inputs)
	if (locale === "fr") return fr_admin_dashboard_no_upcoming_events(inputs)
	if (locale === "nl") return nl_admin_dashboard_no_upcoming_events(inputs)
	if (locale === "it") return it_admin_dashboard_no_upcoming_events(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_no_upcoming_events(inputs)
	if (locale === "pl") return pl_admin_dashboard_no_upcoming_events(inputs)
	if (locale === "hu") return hu_admin_dashboard_no_upcoming_events(inputs)
	return ro_admin_dashboard_no_upcoming_events(inputs)
});
export { admin_dashboard_no_upcoming_events as "admin.dashboard.no_upcoming_events" }